import { useState } from 'react'
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import VenvGpt from './pages/venvGpt.jsx';
import { Route, Routes } from 'react-router-dom';
import { AuthContextProvider } from './context/AuthContext.js';
import LoginPage from './pages/login.jsx';
import styled from "styled-components";

function App() {
  
  return (
    
    <div>
      <AuthContextProvider>
        <Routes>
          <Route path="/" element={<VenvGpt />} />
         <Route path="/login" element={<LoginPage />} /> 
        </Routes>
        </AuthContextProvider>
    </div>
  )
}

export default App    